import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { ActuatorSection } from "@/components/ActuatorSection";
import { Gallery } from "@/components/Gallery";
import { Brands } from "@/components/Brands";
import { FAQ } from "@/components/FAQ";
import { BlogSection } from "@/components/BlogSection";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { LightboxProvider } from "@/components/Lightbox";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
    }
  }, [hash]);

  return (
    <LightboxProvider>
    <div className="bg-[#0a0a0b]" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Process />
        <Brands />
        <ActuatorSection />
        <Gallery />
        <FAQ />
        <BlogSection />
        <Contact />
      </main>
      <Footer />
    </div>
    </LightboxProvider>
  );
}
